import { React, useState, useEffect, createRef } from "react";
import { useSelector } from 'react-redux';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { Card, CardBody, CardHeader, CardSubtitle, CardTitle } from '@progress/kendo-react-layout';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Form, FormElement } from "@progress/kendo-react-form";
import { Checkbox, Input } from "@progress/kendo-react-inputs";

const NotificationListView = (props) => {
  const [targetNotification, setTargetNotification] = useState([]);
  const [filteredNotification, setFilteredNotification] = useState([]);
  const [filter, setFilter] = useState('');

  const _exporter = createRef();
  const excelExport = () => {
      if (_exporter.current) {
          _exporter.current.save();
      }
  };

  const filterOnChange = (e) => {
    setFilter(e.target.value)
  }
  
  useEffect(() => {
      if (targetNotification && targetNotification.toList) {
        setFilteredNotification(
          JSON.parse(targetNotification.toList).filter((list) => list?.toLowerCase()?.includes(filter?.toLowerCase()))
        )
      }
  }, [filter, targetNotification]);

  useEffect(() => {
    if (props.dataItem && props.dataItem.toList) {
      setTargetNotification(props.dataItem);
      setFilteredNotification(JSON.parse(props.dataItem.toList))
    }
  }, [props])
  
  return <Dialog title={props.dataItem.notificationSubject} onClose={props.cancelEdit} className='flo-kendo-dialog'>
    <Form
      initialValues={props.item}
      render={(formRenderProps) => (
        <FormElement style={styles.formElement}>
          <fieldset className={"k-form-fieldset"} style={{ maxHeight: '600px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
              <Input
                value={filter}
                label="Search"
                onChange={filterOnChange}
                style={{ width: '350px', paddingRight: '20px' }} />
              {
                filter && (
                  <div style={{ paddingTop: '18px', paddingRight: '20px' }}>
                    <Button
                      iconClass={'k-icon k-i-x'}
                      className="k-button k-primary"
                      onClick={() => {
                        setFilter('')
                      }}>
                    </Button>
                  </div>
                )
              }
              <Button type="button" onClick={excelExport}>
                Export to Excel
              </Button>
              <ExcelExport 
                fileName={"Notification: To List - "+ props.dataItem.notificationSubject} 
                data={filteredNotification.map((email) => {return { user: email } })}

                ref={_exporter}>
                  <ExcelExportColumn field="user" title="User" />
              </ExcelExport>
            </div>
            <div style={{ overflowY: 'auto', height: '375px' }}>
              <div style={{ paddingLeft: '10px' }}>
                <div style={{ paddingLeft: '15px', display: 'inline' }}>
                  {
                    filteredNotification.map((email) => 
                      <div>
                        {email}
                      </div>
                    )
                  }
                 </div>
              </div>
            </div>
          </fieldset>
          <div className="k-form-buttons k-justify-content-end">
            <button type={"submit"} className="k-button" style={styles.modalBtn} onClick={props.cancelEdit}>
              Close
            </button>
          </div>
        </FormElement>
      )}
    />
  </Dialog >
}

const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Indent,  
  Undo,
  Redo,
  FontSize,
  FontName,
  Link,
  Unlink,
  InsertImage,
} = EditorTools

const EmailBuilderContent = ({ to, bcc, subject, body }) => {
  const toData = JSON.parse(to).map((email) => { 
    return { name: email, id: email } 
  });

  const bccData = JSON.parse(bcc).map((email) => { 
    return { name: email, id: email } 
  })

  useEffect(() => {
    let editor = document.getElementsByClassName('k-editor')[0]
    let iFrame = editor.querySelector('iframe')
    iFrame.contentDocument.querySelector('.k-content').setAttribute('contenteditable', false)
  }, [])

  return <Card style={styles.card}>
  <CardHeader className='k-hbox' style={styles.cardHeader}>
    <CardTitle style={styles.cardTitle}>Email Builder</CardTitle>
    <CardSubtitle style={styles.cardSubtitle}>
      To:
      <MultiSelect
        style={{ 
          width: '80%',
          paddingLeft: '20px',
          paddingBottom: '20px',
          marginRight: '17%'
        }}
        disabled
        value={toData}
        data={toData}
        textField="name"
        dataItemKey="id"/>
      <div style={{ display: 'inline', paddingRight: '20px' }}>Subject:</div>
      <Input style={{ width: '77%' }} value={subject} disabled/>
      <div>
        BCC:
        <MultiSelect
          style={{ 
            width: '79.4%',
            paddingLeft: '20px',
            paddingBottom: '20px',
            paddingTop: '20px',
            marginRight: '17%'
          }}
          value={bccData}
          data={bccData}
          disabled
          textField="name"
          dataItemKey="id"/>
      </div>

    </CardSubtitle>
  </CardHeader>
  <CardBody>      
    <Editor 
      disabled
      value={body}
      tools={[
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,  
        Undo,
        Redo,
        FontSize,
        FontName,
        Link,
        Unlink,
        InsertImage,
      ]}
    />
    </CardBody>
  </Card>
}

const styles = {
  formElement: {
    width: 800,
    overflow: 'none'
  },
  modalBtn: {
    padding: '10px 15px',
  },  
  card: {
    minWidth: 800,
    margin: 5,
  },
  cardHeader: {
    flexDirection: 'column',
    minHeight: '185px',
    overflowY: 'auto'
  },
  cardTitle: {
    paddingTop: 10
  },
  cardSubtitle: {
    maxHeight: 100,
    marginTop: 5
  }
}

export default NotificationListView;